import { render } from "./BankUpdateRequestsList.vue?vue&type=template&id=79f0b704&scoped=true&ts=true"
import script from "./BankUpdateRequestsList.vue?vue&type=script&lang=ts"
export * from "./BankUpdateRequestsList.vue?vue&type=script&lang=ts"

import "./BankUpdateRequestsList.vue?vue&type=style&index=0&id=79f0b704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f0b704"]])

export default __exports__